import { render, staticRenderFns } from "./testDetails.vue?vue&type=template&id=04bfd286"
import script from "./testDetails.vue?vue&type=script&lang=js"
export * from "./testDetails.vue?vue&type=script&lang=js"
import style0 from "./testDetails.vue?vue&type=style&index=0&id=04bfd286&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports